import { Button, HFlow, Theme, useStyles } from 'bold-ui'
import { useErrorHandler } from 'components/error'
import { PageContent } from 'components/layout/PageContent'
import { confirm } from 'components/modals/confirm'
import { useCancelarAtendimentoMutation } from 'graphql/hooks.generated'
import { useCallback } from 'react'
import { useHistory } from 'react-router'

import { TipoAtendimentoFooter } from '../model-atendimento'
import { atendimentoFooterMessage } from './atendimentoFooterMessage'

export interface AtendimentoFooterProps {
  atendimentoId: ID
  isRegistroTardio: boolean
  isAtendimentoObservacao: boolean
  isObservacaoAndResponsavel: boolean
  clearCache(updateState?: boolean): void
  tipoAtendimentoProfissional?: TipoAtendimentoFooter
}

export function AtendimentoFooter(props: AtendimentoFooterProps) {
  const {
    atendimentoId,
    clearCache,
    tipoAtendimentoProfissional,
    isRegistroTardio,
    isAtendimentoObservacao,
    isObservacaoAndResponsavel,
  } = props
  const history = useHistory()
  const [cancelar, { loading: isLoadingCancelar }] = useCancelarAtendimentoMutation()
  const handleRejection = useErrorHandler()
  const { classes } = useStyles(createStyles)
  const messages = atendimentoFooterMessage(
    tipoAtendimentoProfissional,
    isAtendimentoObservacao,
    isObservacaoAndResponsavel
  )

  const handleCancelar = useCallback(() => {
    return confirm({
      title: messages.confirmTitle,
      body: messages.body,
      confirmLabel: 'Sim, cancelar',
      cancelLabel: 'Não, continuar aqui',
      onConfirm: () => {
        cancelar({ variables: { atendimentoId } })
          .then(() => {
            clearCache(false)
            return history.push(isRegistroTardio ? '/registroTardio' : '/lista-atendimento')
          })
          .catch(handleRejection)
      },
    })()
  }, [
    atendimentoId,
    cancelar,
    clearCache,
    handleRejection,
    history,
    messages.body,
    messages.confirmTitle,
    isRegistroTardio,
  ])

  return (
    <div className={classes.actions}>
      <PageContent type='filled' fluid>
        <HFlow justifyContent='flex-end'>
          <Button kind='normal' onClick={handleCancelar} loading={isLoadingCancelar} disabled={isLoadingCancelar}>
            {messages.labelButton}
          </Button>
        </HFlow>
      </PageContent>
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  actions: {
    borderTop: `1px solid ${theme.pallete.divider}`,
    height: '6.125rem',
  },
})
